import { useLingui } from '@lingui/react/macro'

import { TopArea } from './_blocks/TopArea'
import { ReviewFeatures } from './_blocks/ReviewFeatures'
import { ReviewHowTo } from './_blocks/ReviewHowTo'
import { MoreReview } from './_blocks/MoreReview'
import { ReviewCta } from './_blocks/ReviewCta'

import type { TTadViewDataProps } from '../../_services'
import type { FC } from 'react'

import LazyImage from '@/components/LazyImage'
import Breadcrumb from '@/components/Breadcrumb'
import { Faq } from '@/pages/tad.ai/_components/Faq'


import { useMemo } from 'react';
export const ReviewPage: FC<TTadViewDataProps> = (props) => {
  const { pageData } = props
  const { t } = useLingui()
  const moreReviewData = pageData.more_reviews?.data || []

  const breadcrumb = useMemo(() => {
    const result = [
      {
        name: t`Home`,
        href: `/`,
      },
      {
        name: t`AI Music Generator`,
        href: `/ai-music-generator`,
      },
    ]
    if (pageData.breadcrumb) {
      result.push(...pageData.breadcrumb)
    }

    return result
  }, [pageData.breadcrumb, t])

  return (
    <>
      <div className='relative'>
        <LazyImage
          fill
          src={'/images/index/top-bg.jpg'}
          alt={t`About Us`}
          className='max-h-[1150px]'
        />
        {breadcrumb?.length > 2 ? (
          <Breadcrumb
            className='[&_span]:text-f-text-tertiary relative z-[1] mx-auto !mt-0 flex max-w-[1632px] items-center px-4 pt-[88px] text-sm sm:px-3 md:pt-16 2xl:px-8 [&_a]:font-normal'
            data={breadcrumb}
          />
        ) : null}
        <TopArea
          h1={pageData.h1}
          h1Desc={pageData.h1Desc}
          btnText={pageData.btnText}
          img={pageData.img}
        />
      </div>

      <ReviewFeatures features={pageData.features} />
      <ReviewHowTo howTo={pageData.howTo} />
      {moreReviewData.length ? (
        <MoreReview title={pageData.discoverTitle} data={moreReviewData} />
      ) : null}
      <div className='relative'>
        <LazyImage fill src={'/images/index/bottom-bg.jpg'} alt={'bottom'} />
        {pageData.faqs ? (
          <Faq
            isCms
            className='relative z-[1] pt-14 md:pt-[140px]'
            h2={pageData.faqs?.h2}
            faqList={pageData.faqs?.faqList}
          />
        ) : null}
        <ReviewCta cta={pageData.cta} />
      </div>
    </>
  )
}
